{
  "hero": {
    "title": "Gold verdienen, <em>als wäre es dein Job.<br/></em>",
    "subtitle": "Server­übergreifende Flipping-Intelligenz für das Retail-Auktionshaus. Live-Daten, aufbereitet als konkrete Deals — keine weiteren Charts zum Lesen.",
    "ctaPrimary": "Kostenlos starten",
    "ctaSecondary": "In Aktion sehen",
    "stats": {
      "regions": "Regionen",
      "regionsValue": "EU · US",
      "updated": "Aktualisierung",
      "updatedValue": "Stündlich"
    }
  },
  "toolsSection": {
    "label": "Tools",
    "sectionTitle": "Sechs Instrumente. Ein Ziel: Gold.",
    "watchDemo": "Demo ansehen",
    "tags": {
      "flippingTool": "Cross-Server",
      "dropshipTool": "Leere Märkte",
      "realmStats": "Marktdaten",
      "tsmListGenerator": "TSM-Export",
      "snipeAlerts": "Echtzeit",
      "inventoryAnalysis": "Inventar-Scan"
    }
  },
  "tools": {
    "flippingTool": {
      "title": "Flipping Tool",
      "description": "Cross-Server-Flipping-Tool, das die besten möglichen Deals für einen Gegenstand analysiert.",
      "videoTitle": "Cross-Server Flipping Tool",
      "features": {
        "0": "Finde den besten Deal für einen Gegenstand basierend auf Live-Daten.",
        "1": "Wähle gezielt Server aus, auf denen du kaufen und verkaufen möchtest.",
        "2": "Zeigt den Gold-Gewinn zwischen Kauf- und Verkaufs-Server.",
        "3": "Berechnet den Gewinn % für Verkaufsdurchschnitt vs. Kauf und Verkauf vs. Kauf.",
        "4": "Zeigt genau, von welchem Server/Server-Cluster du kaufen und auf welchem du verkaufen sollst.",
        "5": "Filter/Sortierung für verschiedene Gegenstandstypen und Preisstatistiken"
      }
    },
    "dropshipTool": {
      "title": "Dropship Tool",
      "description": "Dropship-Tool, das zeigt, welche Gegenstände auf einem Server nicht gelistet sind, damit du sie ohne Konkurrenz flippen kannst.",
      "videoTitle": "Dropship Tool",
      "features": {
        "0": "Finde den besten Server zum Verkaufen ohne Konkurrenz",
        "1": "Wähle gezielt Server aus, auf denen du kaufen und verkaufen möchtest.",
        "2": "Zeigt den Gold-Gewinn zwischen Kauf- und Verkaufs-Server.",
        "3": "Berechnet den Gewinn % für Verkaufsdurchschnitt vs. Kauf und Verkauf vs. Kauf.",
        "4": "Zeigt genau, von welchem Server/Server-Cluster du kaufen und auf welchem du verkaufen sollst.",
        "5": "Filter/Sortierung für verschiedene Gegenstandstypen und Preisstatistiken"
      }
    },
    "realmStats": {
      "title": "Server-Statistiken",
      "description": "Statistische Informationen zu jedem Server: Preise und Auktionsdaten. Dies hilft dir zu entscheiden, wo du kaufen und wo du verkaufen solltest.",
      "videoTitle": "Server-Statistiken",
      "features": {
        "0": "Finde Preisinformationen zu jedem Server",
        "1": "Finde heraus, welcher Server hoch oder niedrig verkauft"
      }
    },
    "tsmListGenerator": {
      "title": "TSM-Listengenerator",
      "description": "Erweitertes TSM-Listengenerator-Tool zur Erstellung benutzerdefinierter Gegenstandslisten auf Basis von Daten.",
      "videoTitle": "TSM-Listengenerator",
      "features": {
        "0": "Nutze mehrere Preisquellen, um die besten Gegenstände herauszufiltern",
        "1": "Erstelle die perfekte TSM-Liste auf Basis einer grossen Datenmenge.",
        "2": "Exportiere deine benutzerdefinierte TSM-Liste mit 1 Klick."
      }
    },
    "snipeAlerts": {
      "title": "Snipe Alerts",
      "description": "Werde benachrichtigt, sobald unterbewertete Gegenstände, Haustiere oder ilvl-BoEs im Auktionshaus erscheinen — bevor jemand anders sie schnappt.",
      "videoTitle": "Snipe Alerts Preview",
      "features": {
        "0": "Überwache Gegenstände, Kampfhaustiere und ilvl-BoEs unter deinem Zielpreis.",
        "1": "Erhalte sofortige Discord-DM- oder Webhook-Benachrichtigungen bei einem Snipe.",
        "2": "Konfiguriere Schwellenwerte pro Gegenstand über eine schlichte, klare Oberfläche."
      }
    },
    "inventoryAnalysis": {
      "title": "Inventaranalyse",
      "description": "Füge dein FlipQueue-Addon-Inventar-CSV ein, um sofort zu sehen, welche Gegenstände sich serverübergreifend zum Flippen lohnen. Nutze das Ergebnis im Addon, um auf den besten Servern zu verkaufen.",
      "videoTitle": "Inventaranalyse",
      "features": {
        "0": "Analysiere dein aktuelles Inventar gegen Live-Cross-Server-Preise.",
        "1": "Erkenne sofort, welche Gegenstände in deinen Taschen profitabel sind."
      }
    }
  },
  "edge": {
    "label": "Der Vorteil",
    "sectionTitle": "Warum Mitglieder ihr Abo behalten.",
    "items": {
      "0": {
        "title": "Mehr Gold.",
        "body": "Wir zeigen die margenstärksten Flips pro Aufwandsminute. Deine Gold-pro-Stunde-Rate ist die Zahl, die wir optimieren."
      },
      "1": {
        "title": "Mehr Freizeit.",
        "body": "Stundenlange TSM-Scans schrumpfen auf eine durchsuchbare Oberfläche. Filtern, sortieren, TSM-Liste exportieren, fertig."
      },
      "2": {
        "title": "Heute Abend loslegen.",
        "body": "Keine Tabellen, kein Addon-Wirrwarr. Die meisten Mitglieder machen am ersten Tag ihren ersten profitablen Flip."
      }
    }
  },
  "reviews": {
    "label": "Bewertungen",
    "sectionTitle": "Was unsere Mitglieder sagen.",
    "videoTitle": "FlippingPal Mitglieder-Bewertungen"
  },
  "pricing": {
    "label": "Mitgliedschaft",
    "sectionTitle": "Ein Abo. Alle Tools.",
    "subtitle": "Das Abonnement gibt Zugang zu allen Flipping Pal-Tools"
  },
  "faq": {
    "label": "Fragen",
    "sectionTitle": "Häufig gestellte Fragen.",
    "items": {
      "0": {
        "question": "Habe ich mit dem Monatsabonnement Zugang zu allen Tools?",
        "answer": "Ja, du hast vollen Zugang zu allen Flipping Pal-Tools."
      },
      "1": {
        "question": "Für welche WoW-Region funktioniert das?",
        "answer": "Sowohl für US (NA) als auch für EU (Europa)."
      },
      "2": {
        "question": "Kann ich mein Abonnement jederzeit kündigen?",
        "answer": "Ja, du kannst dein Abonnement jederzeit kündigen. Nach der Kündigung verlierst du den Zugriff auf die Tools."
      },
      "3": {
        "question": "Welche Zahlungsmethoden werden akzeptiert?",
        "answer": "Jede Debit- oder Kreditkarte."
      },
      "4": {
        "question": "Erhalte ich Hilfe, wenn ich Fragen habe?",
        "answer": "Ja, wenn du Fragen hast, wende dich an das Team im Discord."
      }
    }
  },
  "modal": {
    "close": "Schliessen"
  },
  "backToTop": "Zurück nach oben",
  "footerCta": {
    "joinAsAffiliate": "Als Partner beitreten",
    "contactUs": "Kontaktiere uns",
    "discord": "Discord",
    "refundPolicy": "Rückerstattungsrichtlinie",
    "privacyPolicy": "Datenschutzrichtlinie",
    "termsAndConditions": "Nutzungsbedingungen",
    "copyright": "© 2026 Flipping Pal - Alle Rechte vorbehalten. Von",
    "creatorLabel": "Boophie (Content Creator)"
  }
}
